import { create } from 'zustand';

interface Toast {
  id: number;
  message: string;
  icon?: string;
}

interface ToastStore {
  toasts: Toast[];
  addToast: (message: string, icon?: string) => void;
}

const useToastStore = create<ToastStore>(set => ({
  toasts: [],
  addToast: (message, icon) => {
    const id = Date.now();
    set(state => ({
      toasts: [...state.toasts, { id, message, icon }],
    }));

    // Удаляем уведомление через 3 секунды
    setTimeout(() => {
      set(state => ({
        toasts: state.toasts.filter(toast => toast.id !== id),
      }));
    }, 3000);
  },
}));

export default useToastStore;
